import { apiClient } from "./apiClient";
import { baseURL } from "../utils/url";

export const getInternalToken = async () => {
  const res = await fetch(baseURL + "unityToken", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res.json();
};

export const unityFulfilmentToken = async () => {
  const res = await fetch(baseURL + "unityFulfilmentToken", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res.json();
};

export const getCustomer = async (token, mobile) => {
  const res = await fetch(baseURL + "getUnityCustomer", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ mobile }),
  });

  return res.json();
};

export const generateOtp = async (body) => {
  return apiClient(baseURL + "generateMobileOtp", {
    method: "POST",
    body: JSON.stringify(body),
  });
};

export const verifyOtp = async (otp, mobile) => {
  return apiClient(
    `${baseURL}mobileOtpVerification?otp=${otp}&mobile=+91${mobile}`,
    {
      method: "POST",
      body: JSON.stringify({}),
    }
  );
};

export const getVoucher = async (token, mobile, voucherCode) => {
  const res = await fetch(baseURL + "getUnityVoucher", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ mobile, voucherCode }),
  });

  return res.json();
};

export const unityVoucherAssign = async (token, body) => {
  const res = await fetch(baseURL + "unityVoucherAssign", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  return res.json();
};

export const fetchClaimedVoucher = async (token, code) => {
  const res = await fetch(baseURL + `getUnityClaimedVoucher?code=${code}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });

  return res.json();
}; 
